import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const ChevronLeft: React.FC<IconProps> = ({
  className = '',
  fill = colors.blueGrey,
  viewBox = '0 0 7 15',
  d = 'M0,3.15L4.35,7.5L0,11.827L1.337,13.163L7,7.5L1.337,1.837L0,3.15Z',
  transition = 'fill 0.1s ease-in-out',
  cssHelper = Styling.fullHeightStyle,
  width = 7,
  height = 15,
  focusable
}) => {
  return (
    <Elements.Svg
      viewBox={viewBox}
      className={cx({ [className]: !!className })}
      width={width}
      height={height}
      cssHelper={cssHelper}
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.G transform='matrix(-1,0,0,1,7,0)'>
        <Elements.Path fill={fill} d={d} transition={transition} />
      </Elements.G>
    </Elements.Svg>
  );
};

export default ChevronLeft;
